var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29996 31.6833L4.26663 31.7166C3.81663 30.7333 3.53329 29.6166 3.41663 28.3833C3.53329 29.6 3.84996 30.7 4.29996 31.6833Z",
    fill: "#AAADAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.3C17.1907 17.3 18.9667 15.5241 18.9667 13.3334C18.9667 11.1426 17.1907 9.3667 15 9.3667C12.8093 9.3667 11.0333 11.1426 11.0333 13.3334C11.0333 15.5241 12.8093 17.3 15 17.3Z",
    fill: "#AAADAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9834 3.3335H13.0167C6.95004 3.3335 3.33337 6.95016 3.33337 13.0168V26.9835C3.33337 28.8002 3.65004 30.3835 4.26671 31.7168C5.70004 34.8835 8.76671 36.6668 13.0167 36.6668H26.9834C33.05 36.6668 36.6667 33.0502 36.6667 26.9835V23.1668V13.0168C36.6667 6.95016 33.05 3.3335 26.9834 3.3335ZM33.95 20.8335C32.65 19.7168 30.55 19.7168 29.25 20.8335L22.3167 26.7835C21.0167 27.9002 18.9167 27.9002 17.6167 26.7835L17.05 26.3168C15.8667 25.2835 13.9834 25.1835 12.65 26.0835L6.41671 30.2668C6.05004 29.3335 5.83337 28.2502 5.83337 26.9835V13.0168C5.83337 8.31683 8.31671 5.8335 13.0167 5.8335H26.9834C31.6834 5.8335 34.1667 8.31683 34.1667 13.0168V21.0168L33.95 20.8335Z",
    fill: "#AAADAF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.81c3b03734490468abfcc47ec02bded8.svg";
export { ForwardRef as ReactComponent };